module.exports = __webpack_public_path__ + "static/img/apply5.cbae2931.png";